export const MAX_TITLE_LENGTH = 25
export const MAX_DESCRIPTION_LENGTH = 100
export const DEFAULT_COLOR = '#FFFFFF'
